const CONSOLE_DEBUGGING_ENABLED = false;

export default {
    log: (message) => {
        if (CONSOLE_DEBUGGING_ENABLED || process?.env?.NODE_ENV === "development") {
            // eslint-disable-next-line no-console
            console.log(message);
        }
    }
};